/* eslint-disable no-unused-vars */
/* eslint-disable consistent-return */
/* eslint-disable import/order */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable eqeqeq */
/* eslint-disable no-return-assign */
/* eslint-disable object-shorthand */
/* eslint-disable camelcase */
import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  makeStyles,
  withStyles,
} from '@material-ui/core'
import React, { useEffect, useRef, useState } from 'react'
import {
  StyledTableCellBody,
  StyledTableCellHeader,
} from '../../../../components/hooks/BaseTableComponents'
import { mdiAccountMinus } from '@mdi/js'
import Icon from '@mdi/react'
import colors from '../../../../assets/colors'
import {
  Link,
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min'
import { useConfirm } from 'material-ui-confirm'
import { useDispatch, useSelector } from 'react-redux'
import { removeAppointment } from '../AppointmentsActions'
import { usePermissions } from '../../../../hooks/usePermission'
import Pagination from '../../../../components/hooks/BasePagination'
import { useQueryParams } from '../../../../util/utils'
import filterStylesComponents from '../../../../assets/filterComponentsStyles'

import styles from '../../../../resources/theme/global'

const useStyles = makeStyles(theme => ({
  indicator: {
    height: '26px',
    width: '2px',
    borderRadius: '5px',
  },
  status: {
    textAlign: 'center',
    fontSize: '14p',
    borderRadius: '10px',
    padding: '4px 16px',
    maxWidth: '80px',
    backgroundColor: colors.graylight,
    color: '#000',
  },
  statusAtivo: {
    color: '#FFFF',
    backgroundColor: colors.secondary,
  },
}))

const List = props => {
  const classes = useStyles()
  const styles = filterStylesComponents()

  const confirm = useConfirm()
  const dispatch = useDispatch()

  const { classes: global } = props

  const items = useSelector(state => state.appointments.items)
  const meta = useSelector(state => state.appointments.meta)
  const permissionUser = useSelector(state => state.auth.permissionUser)
  const { canDelete } = usePermissions()

  const location = useLocation()
  const filters = useQueryParams(location.search)
  const history = useHistory()

  const handleSubmit = data => {
    const searchParams = new URLSearchParams(data || filters)
    history.push(`${location?.pathname}?${searchParams?.toString()}`)
  }

  const handleChangeRowsPerPage = event => {
    const data = { ...filters, rows: event.target.value, page: 1 }
    handleSubmit(data)
  }

  const handleChangePage = (event, newPage) => {
    const data = { ...filters, page: newPage }
    handleSubmit(data)
  }

  const handleDelet = async id => {
    confirm({
      description: 'Deseja cancelar esse agendamento?',
      title: 'Tem certeza?',
      confirmationText: 'Sim',
      cancellationText: 'Cancelar',
      dialogProps: {
        fullWidth: true,
      },
    }).then(() => {
      dispatch(removeAppointment(id))
      handleSubmit(filters)
    })
  }

  return (
    <>
      <TableContainer className={global.tableStickHeader}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <StyledTableCellHeader />
              <StyledTableCellHeader align="left">
                Lavanderia
              </StyledTableCellHeader>
              <StyledTableCellHeader align="left">
                Técnico
              </StyledTableCellHeader>
              <StyledTableCellHeader align="left">Data</StyledTableCellHeader>
              <StyledTableCellHeader align="left">Status</StyledTableCellHeader>
              <StyledTableCellHeader align="left">
                Delivery
              </StyledTableCellHeader>
              <StyledTableCellHeader align="left">
                Observação
              </StyledTableCellHeader>
              <StyledTableCellHeader align="center">
                Ações
              </StyledTableCellHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {items?.map(appointment => (
              <TableRow key={appointment?.id} hover>
                <StyledTableCellBody>
                  <Box
                    className={classes.indicator}
                    style={{ backgroundColor: appointment?.attendant_color }}
                  />
                </StyledTableCellBody>
                <StyledTableCellBody>
                  {appointment?.laundry}
                </StyledTableCellBody>

                <StyledTableCellBody>
                  {appointment?.attendant}
                </StyledTableCellBody>
                <StyledTableCellBody>{appointment?.date}</StyledTableCellBody>
                <StyledTableCellBody>
                  {appointment?.deleted_at ? 'Fechado' : 'Aberto'}
                </StyledTableCellBody>
                <StyledTableCellBody>
                  {appointment?.is_delivery ? 'Sim' : 'Não'}
                </StyledTableCellBody>
                <StyledTableCellBody>
                  {appointment?.observation || '-'}
                </StyledTableCellBody>
                <StyledTableCellBody align="center">
                  {!appointment?.deleted_at && canDelete('modulo-parceiros-agendamentos', permissionUser) && (
                    <IconButton
                      onClick={() => {
                        handleDelet(appointment.id)
                      }}
                      className={styles.btnSalvar}
                      style={{ backgroundColor: colors.error }}
                    >
                      <Icon
                        path={mdiAccountMinus}
                        size={1}
                        style={{ marginRight: '4px' }}
                      />
                      Deletar
                    </IconButton>
                  )}
                </StyledTableCellBody>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Pagination
        from={meta?.from}
        to={meta?.to}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        rowsPerPage={Number(meta?.per_page)}
        rows={meta?.total}
        page={meta?.current_page}
        handleChangePage={handleChangePage}
      />
    </>
  )
}

export default withStyles(styles)(List)
